import { SxProps } from '@mui/material';

export const formFieldContainerStyles: SxProps = {
  mb: 1,
  height: '60px',
  position: 'relative',
};

export const formControlStyles: SxProps = {
  '& .MuiFormHelperText-root': {
    position: 'absolute',
    bottom: '-20px',
    left: 0,
    margin: 0,
    fontSize: '0.75rem',
  },
  '& .MuiSelect-select': {
    paddingTop: '4px',
    paddingBottom: '4px',
    minHeight: 'auto',
    lineHeight: '1.2',
  },
  '& .MuiInputBase-root': {
    paddingTop: '0px',
    paddingBottom: '0px',
  },
};


export const taxItemContainerStyles: SxProps = {
  display: 'flex',
  alignItems: 'flex-end',
  height: '60px',
  position: 'relative',
  mb: 1,
};

export const taxDeleteButtonContainerStyles: SxProps = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
  paddingBottom: '8px',
};

export const taxDeleteButtonStyles: SxProps = {
  height: '40px',
  minWidth: '50px',
  '& .MuiSvgIcon-root': {
    color: 'white',
    fontSize: '20px',
  },
};
